import React from "react";
import { Modal } from "antd";
import { InjectBaseModalProps } from "@/hooks/Modal/ModalStore";
import ConsigneeManagementForm from "./ConsigneeManagementForm";

interface ConsigneeManagementModalProps extends InjectBaseModalProps {
    shopId: number;
}

const ConsigneeManagementModal: React.FC<ConsigneeManagementModalProps> = ({ open, onCancel, shopId }) => (
    <Modal
        width={900}
        title={
            <span>
                常用收货人管理
                <a
                    href="https://qw15p3s8hv.feishu.cn/wiki/wikcnOCvrqlMpZX4D4trVMVEonS"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    （点击查看这功能有什么用？）
                </a>
            </span>
        }
        open={open}
        onCancel={onCancel}
        okButtonProps={{ hidden: true }}
        destroyOnHidden
    >
        <ConsigneeManagementForm shopId={shopId} />
    </Modal>
);

export default ConsigneeManagementModal;
